import { useState } from "react";
import SoftBox from "components/SoftBox";
import SlugTabs from "cxfcomponents/SlugTabs";
import { Overview } from "./overview";
import { useSlugIntegration } from "hooks/useSlugIntegration";
import { FlowsTab } from "./flows";
import { UsersTab } from "./users";

const tabsData = ["overview", "users", "flows"];

export const IntegrationTabs = () => {
  const { integration } = useSlugIntegration();
  const [currentTab, setCurrentTab] = useState("overview");

  const renderTab = () => {
    switch (currentTab) {
      case "overview":
        return <Overview integration={integration} />;
      case "users":
        return <UsersTab integration={integration} />;
      case "flows":
        return <FlowsTab integration={integration} />;
    }

    return <></>;
  };

  if (!integration) return <></>;

  return (
    <SoftBox>
      <SoftBox>
        <SlugTabs tabs={tabsData} value={currentTab} onChange={setCurrentTab} />
        {renderTab()}
      </SoftBox>
    </SoftBox>
  );
};
